import { ReactNode } from 'react';
import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  proLabel,
  defaultText,
  deferredPayment,
  newDefaultText
} = translate({
  "proLabel": "Professionals, get Pro prices excl. VAT",
  "defaultText": "+ 600,000 Pro references at negotiated price",
  "newDefaultText": "+ 400,000 Pro references at negotiated price",
  "deferredPayment": "Deferred payment up to 30 days"
});
export const proWelcomeOfferDiscount = translateFormatter<{
  couponAmount: string;
}>("{couponAmount} off", undefined, undefined, "en");
export const proWelcomeOfferlabel = translateFormatter<{
  span: RichTextFormatter;
  discount: Record<string, any>;
}>("<span>{ discount }</span> on your 1st purchase", undefined, undefined, "en");
export const proWelcomeOfferlabelMultiCoupon = translateFormatter<{
  span: RichTextFormatter;
  discount: Record<string, any>;
}>("<span>{ discount }</span> on your first purchases", undefined, undefined, "en");
export const proCouponlabel = translateFormatter<{
  span: RichTextFormatter;
  discount: JSX.Element;
}>("<span>-{ discount }</span> in this product for pros", undefined, undefined, "en");
export const b2bAdvantageTextV2 = translateFormatter<{
  percentage: ReactNode;
}>("Pro Price: save {percentage} on this product", undefined, undefined, "en");